var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150C116.421 150 150 116.421 150 75Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.354 58H60.471C58.4914 58.0058 56.5944 58.7948 55.1946 60.1946C53.7948 61.5944 53.0058 63.4914 53 65.471V84.147C53.0058 86.1266 53.7948 88.0236 55.1946 89.4234C56.5944 90.8232 58.4914 91.6122 60.471 91.618H90.354C92.3336 91.6122 94.2306 90.8232 95.6304 89.4234C97.0302 88.0236 97.8192 86.1266 97.825 84.147V65.471C97.8192 63.4914 97.0302 61.5944 95.6304 60.1946C94.2306 58.7948 92.3336 58.0058 90.354 58ZM93.342 68.833L78.587 78.733C77.6308 79.3217 76.5347 79.6442 75.412 79.667C74.2893 79.6442 73.1932 79.3217 72.237 78.733L57.482 68.833C57.1078 68.5202 56.8625 68.08 56.7935 67.5972C56.7244 67.1144 56.8365 66.6231 57.108 66.218C57.4208 65.8438 57.861 65.5985 58.3438 65.5295C58.8266 65.4604 59.3179 65.5725 59.723 65.844L74.478 75.744C74.7892 75.9274 75.1438 76.0241 75.505 76.0241C75.8662 76.0241 76.2208 75.9274 76.532 75.744L91.287 65.844C91.4931 65.7017 91.7262 65.603 91.9718 65.5541C92.2174 65.5052 92.4705 65.507 92.7154 65.5594C92.9603 65.6119 93.1919 65.7138 93.396 65.8591C93.6 66.0043 93.7722 66.1898 93.902 66.404C94.0908 66.8137 94.1383 67.2745 94.0369 67.7142C93.9356 68.1538 93.6911 68.5473 93.342 68.833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.6a26a161ba413cbc0055fe9b8b598be3.svg";
export { ForwardRef as ReactComponent };